import {
  EnhancedDesignType,
  TemplateType,
} from '../../../../store/types/template';

export const allowedDesignsForTemplateType = (
  templateType: TemplateType
): EnhancedDesignType[] => {
  if (templateType === 'generic' || templateType === 'loyalty') {
    return ['generic'];
  }
  if (templateType === 'eventTicket') {
    return ['generic', 'eventTicket'];
  }
  return [];
};

export const designRequiresTemplateNfc = (
  design: EnhancedDesignType | null
): boolean => design === 'eventTicket';

export const shouldClearEnhancedDesignImageErrors = (
  storedDesign: EnhancedDesignType | null,
  nextType: TemplateType
): boolean =>
  storedDesign !== null &&
  !allowedDesignsForTemplateType(nextType).includes(storedDesign);
